import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAuth } from "../lib/auth";
import { Seo } from "../components/Seo";

const field = "w-full border border-border bg-background px-4 py-3.5 text-sm focus:border-accent focus:outline-none";

export default function Login() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (admin) navigate("/admin", { replace: true }); }, [admin, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.toLowerCase().trim(), password);
      toast.success("Welcome back.");
      navigate("/admin", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain flex min-h-screen items-center justify-center bg-primary px-6 text-primary-foreground">
      <Seo title="Admin Login" description="Cummings & Co. admin dashboard login." />
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <span className="mx-auto flex h-12 w-12 items-center justify-center bg-accent font-serif text-2xl text-accent-foreground">C</span>
          <h1 className="mt-6 font-serif text-4xl font-light">Admin Dashboard</h1>
          <p className="mt-2 text-sm text-primary-foreground/60">Cummings &amp; Co. Property Management</p>
        </div>
        <form onSubmit={submit} className="space-y-4 border border-primary-foreground/15 bg-primary p-8" data-testid="login-form">
          <input className={field + " text-foreground"} type="email" placeholder="Email" required
            data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input className={field + " text-foreground"} type="password" placeholder="Password" required
            data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} />
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="flex w-full items-center justify-center gap-2 bg-accent px-6 py-3.5 text-sm font-medium text-accent-foreground transition-opacity hover:opacity-90 disabled:opacity-60">
            <Lock className="h-4 w-4" />
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
